import { useEffect } from 'react';
import type { EngineRefs } from '../refs';
import { retapMasterAnalyser } from '../../graphNodes';

export function useAnalyserTap(refs: EngineRefs, deps: any[]) {
  useEffect(() => {
  const [eqEnabled, eqHpfEnabled, eqLpfEnabled] = deps as [boolean, boolean, boolean];
  retapMasterAnalyser(refs as any, { eqEnabled, eqHpfEnabled, eqLpfEnabled });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
